export default {
    resources: {
        users: {
            name: 'User |||| Users',
            fields: {
                id: 'Id',
                email: 'Email',
                alias: 'Alias',
                maritalStatus: 'Marital Status',
                maleBirthYear: 'Male Birth Year',
                femaleBirthYear: 'Female Birty Year',
                language: 'Language',
                acceptNotifications: 'Accept Notifications',
                questions: 'Questions',
                questionPool: 'Number of available questions',
                tosAccept: 'TOS accepted',
                isActive: 'Active',
            }
        },
        user_answers: {
            name: 'User answer |||| User answers',
            fields: {
                id: 'Id',
                isFantasy: 'Is Fantasy',
                isAction: 'Is Action',
                isSkipped: 'Is Skipped',
                gaugeLevel: 'Gauge Level',
                user: 'User',
                question: 'Question',
                answer: 'Answer'
            }
        },
        questions: {
            name: 'Question |||| Questions',
            fields: {
                id: 'Id',
                label: 'Label',
                complement: 'Complement',
                showFantasy: 'Show Fantasy',
                showAction: 'Show Action',
                showGauge: 'Show Gauge',
                vision: 'Vision',
                notion: 'Notion',
                theme: 'Theme',
                tags: 'Tags',
                pack: 'Thematic',
                answerGroup: 'Answer Group'
            }
        },
        answers: {
            name: 'Answer |||| Answers',
            fields: {
                id: 'Id',
                sequence: 'Sequence',
                label: 'Label',
                weight: 'Weight',
                group: 'Group'
            }
        },
        notion: {
            name: 'Notion |||| Notions',
            fields: {
                id: 'Id',
                label: 'Label'
            }
        },
        packs: {
            name: 'Thematic |||| Thematics',
            fields: {
                id: 'Id',
                label: 'Label',
                sequence: 'Sequence'
            }
        },
        tags: {
            name: 'Tag |||| Tags',
            fields: {
                id: 'Id',
                label: 'Label'
            }
        },
        themes: {
            name: 'Theme |||| Themes',
            fields: {
                id: 'Id',
                label: 'Label'
            }
        },
        visions: {
            name: 'Vision |||| Visions',
            fields: {
                id: 'Id',
                label: 'Label'
            }
        },
        answer_groups: {
            name: 'Answer group |||| Answer groups',
            fields: {
                id: 'Id',
                label: 'Label',
                answers: 'Answer',
                newAnswers: 'New Answers'
            }
        },
        posts: {
            name: 'Post |||| Posts',
            fields: {
                id: 'Id',
                title: 'Title',
                description: 'Description',
                createDate: 'Creation Date',
                updateDate: 'Update Date'
            }
        },
        conditions: {
            name: 'Condition |||| Contitions',
            fields: {
                id: 'Id',
                question: 'Question',
                minWeight: 'Minimum weight',
                maxWeight: 'Maximun weight'
            },
            errors: {
                weight: 'Maximum weight must not be less than minimun weight'
            }
        },
        offers: {
            name: 'Offer |||| Offers',
            fields: {
                questionNumber: 'Question number',
                price: 'Price',
            }
        }
    },
    dashboard: {
        message: 'Dashboard',
    },
    assignQuestions: {
        title: 'Assign questions to user %{id}',
        button: 'Assign questions'
    },
    custom: {input: {autocomplete: {none: 'None'}}},
    'email: user.error.emailExists': 'There is already an account with that email'
};



// WEBPACK FOOTER //
// ./src/i18n/en_US.js